import { render, staticRenderFns } from "./DataInputSelectcolor.vue?vue&type=template&id=5f2dad86&scoped=true&"
import script from "./DataInputSelectcolor.vue?vue&type=script&lang=js&"
export * from "./DataInputSelectcolor.vue?vue&type=script&lang=js&"
import style0 from "./DataInputSelectcolor.vue?vue&type=style&index=0&id=5f2dad86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2dad86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VChip,VCol,VListItem,VListItemContent,VListItemTitle,VRow,VSelect})
